<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading> -->
@if (eventDetailReady$ | async) {
  <app-screen-shell
    [contentClass]="'container'"
    [title]="eventDetailTitle()"
    (back)="editMode ? cancelEventDetailsChange() : goBack()">
    @if (!editMode) {
      <div class="match-overview-layout" data-testid="open-match-preview">
        <section class="match-preview-panel">
          <h2>{{ event.name }}</h2>
          <p>{{ event.nextOccurrenceTimestamp ? (event.nextOccurrenceTimestamp | localizedDate:'EEEE, d MMM') : ('events.timeNotSet' | translate) }}<ng-container *ngIf="event.nextOccurrenceTimestamp"> · {{ event.nextOccurrenceTimestamp | timezone:event.nextOccurrenceTimestampZone:'HH:mm' }}</ng-container></p>
          <p>{{ eventLocationLabel() }}</p>
          <div class="match-fill-summary"><div><strong>{{ event.confirmedCount || 0 }}/{{ event.maxPlayers }}</strong><span>{{ 'guestOwner.coming' | translate }}</span></div><div><strong>{{ event.maxPlayers > event.confirmedCount ? event.maxPlayers - event.confirmedCount : 0 }}</strong><span>{{ 'catchUp.playersNeeded' | translate }}</span></div></div>
          <p *ngIf="event.cancelled">{{ 'events.cancelled' | translate }}</p>
          <p *ngIf="joinError" class="alert alert-danger" role="alert">{{ joinError }}</p>
          <button *ngIf="canRequestJoin()" class="btn btn-primary btn-block" [disabled]="loading" (click)="requestToJoin(event)">{{ 'events.requestToJoin' | translate }}</button>
          <div *ngIf="event.viewedByCandidate"><p>{{ 'events.joinPending' | translate }}</p><button class="btn btn-outline-danger" [disabled]="loading || event.access?.canLeave === false" (click)="withdrawRequest()">{{ 'catchUp.withdrawRequest' | translate }}</button></div>
          <button *ngIf="event.viewedByPlayer || event.viewedByManager" class="btn btn-primary" [routerLink]="['/event-players', false]" [queryParams]="{eventId: event.id}">{{ 'events.details' | translate }}</button>
          <h3 class="mt-4">{{ 'events.openMatchConnectionsTitle' | translate }}</h3>
          <div *ngFor="let connection of event.connectionSummary?.previewPlayers" class="match-home-change"><strong>{{ connection.player.nickName || connection.player.name }}</strong><span>{{ (connection.degree === 'FIRST' ? 'catchUp.playedTogether' : 'catchUp.footballConnection') | translate }}</span></div>
          <p *ngIf="!event.connectionSummary?.previewPlayers?.length">{{ 'events.openMatchConnectionsEmptyText' | translate }}</p>
          <h3 class="mt-4">{{ 'events.rulebook' | translate }}</h3><p class="match-preview-rules">{{ event.rulebook || ('catchUp.noRules' | translate) }}</p>
        </section>
        <section class="match-preview-panel">
          <h3>{{ 'events.openMatchPreviewRhythmTitle' | translate }}</h3>
          <dl class="match-configuration">
            <div><dt>{{ 'catchUp.recurring' | translate }}</dt><dd>{{ previewRecurringKey() | translate }}</dd></div>
            <div><dt>{{ 'events.openMatchPreviewReliabilityLabel' | translate }}</dt><dd>{{ previewReliability() }}</dd></div>
            <div><dt>{{ 'events.players' | translate }}</dt><dd>{{ event.activitySummary?.rosterCount ?? '—' }}</dd></div>
            <div><dt>{{ 'catchUp.activeSince' | translate }}</dt><dd>{{ event.activitySummary?.createdAt ? (event.activitySummary.createdAt | localizedDate:'d MMM yyyy') : '—' }}</dd></div>
          </dl>
          <h3>{{ 'common.location' | translate }}</h3>
          <p>{{ eventLocationLabel() }}</p>
          @if (hasPrecisePlaySpaceLocation()) {
            <google-map height="260px" width="100%" [options]="mapOptions"><map-advanced-marker [position]="{lat: mapLatitude, lng: mapLongitude}"></map-advanced-marker></google-map>
            <a [href]="navigateHref" target="_blank" rel="noopener" class="btn btn-outline-primary mt-3">{{ 'events.seeMap' | translate }}</a>
          }
          <p class="mt-3">{{ 'common.manager' | translate }}: {{ event.manager?.nickName || event.manager?.name }}</p>
        </section>
      </div>
    }
    @if (editMode) {
  <form (ngSubmit)="onSubmit(event.viewedByManager)" autocomplete="off" #eventForm="ngForm" class="col-lg-10 mx-auto">
    <div class="heading">
      <!-- Heading -->
      <div class="d-empty-none mt-lh-n1">
        @if (!editMode) {
          <div class="mt-md-n4 mb-4">
            @if (hasPrecisePlaySpaceLocation()) {
            <a href="{{ navigateHref }}" target="_blank" (click)="openMap()" class="mt-md-n4 mb-4" [title]="'events.seeMap' | translate">
              <i [class]="'locations.location' | nogoshIcon"><span class="sr-only">{{ 'events.seeMap' | translate }}</span></i>&nbsp;{{ event.playSpace.name }}
              <label class="d-inline-block">{{ event.nextOccurrenceTimestamp ? (event.nextOccurrenceTimestamp | timezone: event.nextOccurrenceTimestampZone: 'MMM d yyyy @ HH:mm') + 'h' : ('events.timeNotSet' | translate) }}</label>
            </a>
            }
            @if (!hasPrecisePlaySpaceLocation()) {
              <div class="text-nogosh-grey3">
                <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>&nbsp;{{ eventLocationLabel() }}
                <label class="d-inline-block">{{ event.nextOccurrenceTimestamp ? (event.nextOccurrenceTimestamp | timezone: event.nextOccurrenceTimestampZone: 'MMM d yyyy @ HH:mm') + 'h' : ('events.timeNotSet' | translate) }}</label>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!-- second row - Form elements -->
    <div class="form-group row">
      <!-- //////////////////////////////////////////////////////////////// -->
      <!-- left side -->
      <div class="col-md-6 col-12">
        @if (!event.active) {
          <div>
            <div class="form-group">
              <label for="eventNote4" class="mb-0">{{ 'events.notes' | translate }}</label>
              <textarea class="form-control" [rows]="event.note?.length > 30 ? 5 : 1" id="eventNote4" name="eventNote"
              [(ngModel)]="event.note" [disabled]="!editMode || !event.viewedByManager"></textarea>
            </div>
            <label for="whiteScore"  class="border-bottom d-block">{{ 'events.score' | translate }}</label>
            <div class="d-flex">
              <div class="form-group d-inline-flex flex-column">
                <label for="whiteScore"  class="mb-0">{{ 'events.whites' | translate }}</label>
                <input class="form-control" id="whiteScore" name="whiteScore" [(ngModel)]="event.whiteScore"
                  [disabled]="!(editMode && event.viewedByManager)"/>
              </div>
              <div class="d-inline-flex flex-column px-1"><label>&nbsp;</label><span>:</span></div>
              <div class="form-group d-inline-flex flex-column">
                <label for="blackScore"  class="mb-0">{{ 'events.blacks' | translate }}:</label>
                <input class="form-control" id="blackScore" name="blackScore" [(ngModel)]="event.blackScore"
                  [disabled]="!(editMode && event.viewedByManager)"/>
              </div>
            </div>
          </div>
        }
        @if (!editMode || (editMode && event.active)) {
          <div class="form-group">
            <label for="eventName" class="m-0">{{ 'events.name' | translate }}</label>
            <input type="text" class="form-control" id="eventName" [placeholder]="'validation.matchName' | translate" [(ngModel)]="event.name"
              name="name" [disabled]="!event.active || !editMode || !event.viewedByManager" required>
          </div>
        }
        @if (!editMode || (editMode && event.active)) {
          <div class="form-group" id="eventMaxPlayersSettingsSection">
            <label for="maxPlayers" class="m-0">{{ 'events.maxPlayersPerGame' | translate }}</label>
            <input type="text" class="form-control" id="maxPlayers" [placeholder]="'validation.maxPlayers' | translate" [(ngModel)]="event.maxPlayers"
              name="maxPlayers" [disabled]="!event.active || !editMode || !event.viewedByManager" required>
          </div>
        }
        @if (!editMode) {
          <div class="form-group">
            <label for="eventPlaySpaceName" class="m-0">{{ 'common.location' | translate }}</label>
            <input type="text" class="form-control" id="eventPlaySpaceName"
              [ngModel]="eventLocationLabel()" name="playSpaceName" disabled>
          </div>
        }
        @if (!editMode) {
          <div class="form-group">
            <label for="eventManager" class="m-0">{{ 'events.coordinator' | translate }}</label>
            <input type="text" class="form-control" id="eventManager" [placeholder]="'validation.changeCoordinator' | translate"
              [(ngModel)]="event.manager.name" name="manager" [disabled]="!editMode">
          </div>
        }
        <!-- manager autocomplete -->
        @if (editMode && event.active) {
          <div class="form-group" id="eventManagerSettingsSection">
            <label for="eventManager" class="m-0">{{ 'events.coordinator' | translate }}</label>
            <input [(ngModel)]="autocompleteSelectedPlayer" class="form-control" [placeholder]="'validation.selectManager' | translate"
              (typeaheadOnSelect)="typeaheadManagerEmailSelected($event)"
              [typeahead]="playerDataSource" (typeaheadLoading)="changeTypeaheadLoading($event, 'managerName')"
              (typeaheadNoResults)="changeTypeaheadNoResults($event, 'managerName')"
              typeaheadOptionField="autocompleteName" typeaheadOptionsLimit="10"
              id="eventManagerAutocomplete" #newPlayer autocomplete="off" name="autocompletePlayerPicker" required>
            @if (typeaheadPlayerLoading === true) {
              <div>
                <i [class]="('common.refresh' | nogoshIcon) + ' ng-hide'"></i>
              </div>
            }
            @if (typeaheadPlayerNoResults === true) {
              <div>
                <i [class]="('common.delete' | nogoshIcon) + ' col-sm-offset-1'"></i> {{ 'common.noResults' | translate }}
              </div>
            }
          </div>
        }
        <div>
          <!-- Match location autocomplete - editMode -->
          @if (editMode && event.viewedByManager) {
            <div class="form-group">
              <label for="eventPlaySpaceName" class="m-0">{{ 'common.location' | translate }}</label>
              <input [(ngModel)]="autocompletePlayspace" (blur)="checkIfLocationNameIsSelected()" autocomplete="off"
                name="autocompleteLocationNamePicker" [typeahead]="locationDataSource"
                (typeaheadOnSelect)="typeaheadLocationNameSelected($event)"
                (typeaheadLoading)="changeTypeaheadLoading($event, 'locationName')"
                (typeaheadNoResults)="changeTypeaheadNoResults($event, 'locationName')" typeaheadOptionField="name"
                typeaheadOptionsLimit="10" [placeholder]="'events.locationExistingPlaceholder' | translate" class="form-control">
              @if (typeaheadLocationLoading === true) {
                <div>
                  <i [class]="('common.refresh' | nogoshIcon) + ' ng-hide'"></i>
                </div>
              }
              @if (typeaheadLocationNoResults === true) {
                <div>
                  <i [class]="('common.delete' | nogoshIcon) + ' col-sm-offset-1'"></i> {{ 'common.noResults' | translate }}
                </div>
              }
            </div>
          }
          <p>
            @if (editMode && event.viewedByManager) {
              <a (click)="saveEventState()" [routerLink]="['/playspace', true]">
                <i  [class]="('locations.location' | nogoshIcon) + ' h5 m-0 mr-1 align-middle text-secondary'"></i> <span class="font-weight-500">{{ 'events.addLocation' | translate }}</span> <i [class]="('match.chevronForward' | nogoshIcon) + ' ml-2 align-middle'"></i>
              </a>
            }
          </p>
          @if (editMode && event.viewedByManager && markers.length > 0) {
            <google-map [options]="mapOptions" height="350px" width="100%">
              @for (m of markers; track m; let i = $index) {
                <map-advanced-marker #marker="mapAdvancedMarker" (markerInitialized)="bindAdvancedMarkerClick(marker, $event, i)" [options]="clickableAdvancedMarkerOptions" [position]="m.googleLatLng">
                  <map-info-window>
                    <div class="map-info-card">
                      <div class="map-info-title">{{m.name}}</div>
                      <div class="map-info-row">
                        <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>
                        <span>{{m.address || ('locations.addressMissing' | translate)}}</span>
                      </div>
                      <div class="map-info-grid">
                        <div>
                          <span class="map-info-label">{{ 'locations.workingHours' | translate }}</span>
                          <strong>{{m.workingHours || '-'}}</strong>
                        </div>
                        <div>
                          <span class="map-info-label">{{ 'common.phone' | translate }}</span>
                          <strong>{{m.phone || '-'}}</strong>
                        </div>
                      </div>
                      @if (m.webAddress) {
                        <a class="map-info-link" target="_blank" href="{{m.webAddress}}">
                          <i [class]="'common.externalLink' | nogoshIcon" aria-hidden="true"></i>
                          {{m.webAddress}}
                        </a>
                      }
                      <button type="button" class="btn btn-sm btn-primary map-info-action" (click)="choosePlayLocation(m)">{{ 'events.selectLocation' | translate }}</button>
                    </div>
                  </map-info-window>
                </map-advanced-marker>
              }
            </google-map>
          }
          <!-- <agm-map *ngIf="editMode && event.viewedByManager"
          [latitude]="mapLatitude"
          [longitude]="mapLongitude"
          [zoom]="zoom" [disableDefaultUI]="false" [zoomControl]="false"
          [style.height.px]="350">
          <agm-marker *ngFor="let m of markers" [latitude]="m.latitude" [longitude]="m.longitude" [markerDraggable]="false">
            <agm-info-window>
              <ul class="list-unstyled text-md mb-0">
                <li class="mb-1"><strong class="font-weight-600">{{m.name}}</strong></li>
                <li><span>{{m.address}}, {{m.city.name}}, {{m.city.country.name}}</span></li>
                <li  class="my-1 mt-2"><span>{{ 'locations.workingHours' | translate }}: </span><strong>{{m.workingHours}}</strong></li>
                <li class="my-1"><span>{{ 'common.phone' | translate }}: </span><strong>{{m.phone}}</strong></li>
                <li class="my-1 mb-2"><span>{{ 'events.web' | translate }}: </span><a target="_blank" href="https://{{m.webAddress}}"><strong>{{m.webAddress}}</strong></a><li>
                <li class="mt-2"><strong class="font-weight-500"><a href="" (click)="choosePlayLocation(m); $event.preventDefault()">{{ 'events.selectLocation' | translate }}<i  [class]="('match.chevronForward' | nogoshIcon) + ' ml-2 align-baseline'"></i></a></strong></li>
              </ul>
            </agm-info-window>
          </agm-marker>
        </agm-map> -->
      </div><!-- /.location -->
    </div>
    <!-- //////////////////////////////////////////////////////////////// -->
    <!-- right side -->
    <div class="col-md-6">
      <!-- date picker - editMode -->
      @if (editMode && event.viewedByManager && event.active) {
        <div class="form-group text-center text-md-left mt-3 mt-md-0">
          <label for="eventScheduledDateEdit">{{ 'events.nextOccurrence' | translate }}</label>
          <div class="row">
            <div class="pr-3 pb-3 pe-3 w-auto">
              <bs-datepicker-inline [(bsValue)]="selectedDate" name="eventScheduledDate" id="eventScheduledDateEdit" [minDate]="currentDate" [showWeeks]="false" class="d-picker d-inline-block ml-auto" [bsConfig]="bsConfig"></bs-datepicker-inline>
            </div>
          </div>
          <div class="">
            <div class="">
              <!-- <input type="text" placeholder="Datepicker" bsDatepicker [(ngModel)]="selectedDate" name="eventScheduledDate" id="eventScheduledDateEdit" [minDate]="currentDate" [showWeeks]="false" class="form-control d-picker d-inline-block ml-auto"> -->
            </div>
          </div>
        </div>
      }
      @if (editMode && event.viewedByManager && event.active) {
        <div class="form-group">
          <label class="m-0">{{ 'events.visibility' | translate }}</label>
          <div class="custom-control custom-switch mt-2">
            <input type="checkbox" class="custom-control-input" id="eventOpenToPublic" name="openToPublic" [(ngModel)]="event.openToPublic">
            <label class="custom-control-label" for="eventOpenToPublic">
              {{ (event.openToPublic ? 'events.visibilityOpen' : 'events.visibilityClosed') | translate }}
            </label>
          </div>
          @if (visibilitySuggestion()) {
            <p class="text-nogosh-grey3 small mt-2 mb-0">{{ visibilitySuggestion() }}</p>
          }
        </div>
      }
      <!-- date and time picker - nextOccurrence - editMode -->
      @if (editMode && event.viewedByManager && event.active) {
        <div class="form-group">
          <div class="row flex-column flex-sm-row flex-lg-nowrap">
            <div class="col-auto d-flex align-items-start order-lg-2">
              <strong class="h5 mx-0 my-3">
                {{selectedHour != 0 ? ((selectedHour < 10 ? '0' : '' ) + selectedHour) : '00' }}:{{selectedMinute !=0 ? ((selectedMinute < 10 ? '0' : '' ) + selectedMinute) : '00' }}h
              </strong>
            </div><!-- /.col  -->
            <div class="col flex-column order-1 order-sm-0">
              <table class="table table-borderless d-block d-sm-table m-0 mt-1">
                <tbody class="d-block d-sm-table">
                  <tr class="d-block d-sm-table-row">
                    <td class="p-0 pr-2 align-middle d-block d-sm-table-cell"><label class="mb-0 mb-sm-2" for="hoursRange">{{ 'events.hour' | translate }}: </label></td>
                    <td class="w-100 p-0 align-middle d-block d-sm-table-cell">
                      <input class="custom-range" type="range" id="hoursRange" [(ngModel)]="selectedHour" name="selectedHour" min="0" max="23" step="1">
                    </td>
                  </tr>
                  <tr class="d-block d-sm-table-row">
                    <td class="p-0 pr-2 align-middle d-block d-sm-table-cell"><label class="mb-0 mb-sm-2" for="minutesRange">{{ 'events.minute' | translate }}: </label></td>
                    <td class="w-100 p-0 align-middle d-block d-sm-table-cell">
                      <input class="custom-range" type="range" id="minutesRange" #minutesSlider [(ngModel)]="selectedMinute" name="selectedMinute"
                        min="0" max="59" step="1">
                    </td>
                  </tr>
                  @if (editMode && event.viewedByManager && event.active) {
                    <tr class="d-block d-sm-table-row">
                      <td class="p-0 pr-2 align-middle d-block d-sm-table-cell"><label for="radioRecurringEdit0" class="mb-0 mr-3">{{ 'events.recurring' | translate }}: </label></td>
                      <td class="w-100 p-0 align-middle d-block d-sm-table-cell text-nowrap">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="radioRecurringEdit" name="customRadioInline1" class="custom-control-input" [value]="radioRecurringType.ONE_OFF" [(ngModel)]="event.recurringType" name="radioRecurring">
                          <label class="custom-control-label d-flex align-items-center mr-2 cursor-pointer" for="radioRecurringEdit">{{ 'events.occurrenceOneOff' | translate }}</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="radioRecurringEdit2" name="customRadioInline1" class="custom-control-input" [value]="radioRecurringType.DAILY" [(ngModel)]="event.recurringType" name="radioRecurring">
                          <label class="custom-control-label d-flex align-items-center mr-2  cursor-pointer" for="radioRecurringEdit2">{{ 'events.daily' | translate }}</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="radioRecurringEdit3" name="customRadioInline1" class="custom-control-input" [value]="radioRecurringType.WEEKLY" [(ngModel)]="event.recurringType" name="radioRecurring">
                          <label class="custom-control-label d-flex align-items-center cursor-pointer" for="radioRecurringEdit3">{{ 'events.weekly' | translate }}</label>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div><!-- /.col -->
          </div><!--  /.row -->
        </div>
      }
      <!-- recurring - editMode -->
      <!-- <div class="form-group" *ngIf="editMode && event.viewedByManager && event.active">
      <div>
        <input class="btn btn-primary" type="radio" [(ngModel)]="event.recurringType" name="radioRecurring"
          id="radioRecurringEdit" [value]="radioRecurringType.ONE_OFF"> One-off
          <input class="btn btn-primary" type="radio" [(ngModel)]="event.recurringType" name="radioRecurring"
            id="radioRecurringEdit2" [value]="radioRecurringType.DAILY"> Daily
            <input class="btn btn-primary" type="radio" [(ngModel)]="event.recurringType" name="radioRecurring"
              id="radioRecurringEdit3" [value]="radioRecurringType.WEEKLY"> Weekly
            </div>
          </div>-->
          <!-- details - viewMode -->
          @if (!editMode) {
            <div>
              <div class="form-group">
                <label for="recurringViewMode" class="mb-0">{{ 'events.recurring' | translate }}</label>
                <input type="text" class="form-control" id="recurringViewMode" [(ngModel)]="event.recurringType" name="viewRecurring" disabled>
              </div>
              <div class="form-group">
                <label for="nextOccurrence" class="mb-0">{{ 'events.nextScheduled' | translate }}</label>
                <input value="{{event.nextOccurrenceTimestamp ? (event.nextOccurrenceTimestamp | timezone: event.nextOccurrenceTimestampZone :'dddd, MMM D YYYY @ HH:mm') : ('events.timeNotSet' | translate)}}" [disabled]="!editMode" name="nextOccurrence"
                  [placeholder]="'events.firstSeasonStartPlaceholder' | translate" class="form-control"/>
              </div>
              <div class="form-group">
                <label for="season1StartDate" class="mb-0">{{ 'events.season1Start' | translate }}</label>
                <input value="{{event.season1StartDate | localizedDate:'MMMM d'}}" [disabled]="!editMode" name="seasonDate1"
                  [placeholder]="'events.firstSeasonStartPlaceholder' | translate" class="form-control"/>
              </div>
              @if (!editMode) {
                <div class="form-group">
                  <label for="season2StartDate" class="mb-0">{{ 'events.season2Start' | translate }}</label>
                  <input value="{{event.season2StartDate | localizedDate:'MMMM d'}}" [disabled]="!editMode" name="seasonDate2"
                    [placeholder]="'events.secondSeasonStartPlaceholder' | translate" class="form-control"/>
                </div>
              }
            </div>
          }
        </div>
        <!-- end of second row - main form elements -->
      </div>
      @if (!editMode && hasPrecisePlaySpaceLocation()) {
        <google-map [options]="mapOptions" height="350px" width="100%">
          <map-advanced-marker #marker="mapAdvancedMarker" (markerInitialized)="bindAdvancedMarkerClick(marker, $event, 0)" [options]="clickableAdvancedMarkerOptions" [position]="event.playSpace.googleLatLng">
            <map-info-window>
              <div class="map-info-card">
                <div class="map-info-title">{{event.playSpace.name}}</div>
                <div class="map-info-row">
                  <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>
                  <span>{{event.playSpace.address || ('locations.addressMissing' | translate)}}</span>
                </div>
                <div class="map-info-grid">
                  <div>
                    <span class="map-info-label">{{ 'locations.workingHours' | translate }}</span>
                    <strong>{{event.playSpace.workingHours || '-'}}</strong>
                  </div>
                  <div>
                    <span class="map-info-label">{{ 'common.phone' | translate }}</span>
                    <strong>{{event.playSpace.phone || '-'}}</strong>
                  </div>
                </div>
                @if (event.playSpace.webAddress) {
                  <a class="map-info-link" target="_blank" href="{{event.playSpace.webAddress}}">
                    <i [class]="'common.externalLink' | nogoshIcon" aria-hidden="true"></i>
                    {{event.playSpace.webAddress}}
                  </a>
                }
              </div>
            </map-info-window>
          </map-advanced-marker>
        </google-map>
      }
      <!-- <agm-map *ngIf="!editMode"
      [latitude]="mapLatitude"
      [longitude]="mapLongitude"
      [zoom]="zoom" [disableDefaultUI]="false" [zoomControl]="false"
      [style.height.px]="350">
      <agm-marker [latitude]="event.playSpace.latitude" [longitude]="event.playSpace.longitude" [markerDraggable]="false">
        <agm-info-window>
          <ul class="list-unstyled text-md mb-0">
            <li class="mb-1"><strong class="font-weight-600">{{event.playSpace.name}}</strong></li>
            <li><span>{{event.playSpace.address}}, {{event.playSpace.city.name}}, {{event.playSpace.city.country.name}}</span></li>
            <li  class="my-1 mt-2"><span>{{ 'locations.workingHours' | translate }}: </span><strong>{{event.playSpace.workingHours}}</strong></li>
            <li class="my-1"><span>{{ 'common.phone' | translate }}: </span><strong>{{event.playSpace.phone}}</strong></li>
            <li class="my-1 mb-2"><span>{{ 'events.web' | translate }}: </span><a target="_blank" href="https://{{event.playSpace.webAddress}}"><strong>{{event.playSpace.webAddress}}</strong></a><li>
            <li class="mt-2"><strong class="font-weight-500"><a href="" (click)="choosePlayLocation(m); $event.preventDefault()">{{ 'events.selectLocation' | translate }}<i  [class]="('match.chevronForward' | nogoshIcon) + ' ml-2 align-baseline'"></i></a></strong></li>
          </ul>
        </agm-info-window>
      </agm-marker>
    </agm-map> -->
    <br>
      <!-- third row - rulebook and seasons -->
      <div class="form-group col-xs-12">
        <!-- rulebook -->
        @if (!editMode || (editMode && event.active)) {
          <div class="" id="eventRulesSettingsSection">
            <label for="rulebook">{{ 'events.rulebook' | translate }}</label>
            <textarea [(ngModel)]="event.rulebook" id="rulebook" name="rulebook" [disabled]="!editMode || !event.active"
              [placeholder]="'events.rulebookPlaceholder' | translate" class="form-control"
              [rows]="editMode ? 15 : (event.rulebook?.length < 500 ? 5 : 15)">
            </textarea>
          </div>
        }
        <div class="row justify-content-center align-items-center mt-4" id="eventSeasonsSettingsSection">
          <!-- season 1 -->
          <div class="col-auto mx-auto">
            @if (editMode && event.active) {
              <div class="form-group">
                <label for="season1StartDate">{{ 'events.season1Start' | translate }}</label>
                <div class="col-sm-pull-0 col-xs-pull-2">
                  <div style="display:inline-block; min-height:150px;">
                    <bs-datepicker-inline [(bsValue)]="event.season1StartDate" name="seasonDate1" id="season1StartDate" [showWeeks]="false" class="d-picker d-inline-block ml-auto" [bsConfig]="bsConfig"></bs-datepicker-inline>
                    <!-- <datepicker [(ngModel)]="event.season1StartDate" name="seasonDate1" id="season1StartDate" [showWeeks]="false" class="d-picker"></datepicker> -->
                  </div>
                </div>
              </div>
            }
          </div>
          <!-- season 2 -->
          <div class="col-auto mx-auto">
            @if (editMode && event.active) {
              <div class="form-group">
                <label for="season2StartDate">{{ 'events.season2Start' | translate }}</label>
                <div class="col-sm-pull-0 col-xs-pull-2">
                  <div style="display:inline-block; min-height:150px;">
                    <bs-datepicker-inline [(bsValue)]="event.season2StartDate" name="seasonDate2" id="season2StartDate" [showWeeks]="false" class="d-picker d-inline-block ml-auto" [bsConfig]="bsConfig"></bs-datepicker-inline>
                    <!-- <datepicker [(ngModel)]="event.season2StartDate" name="seasonDate2" id="season2StartDate" [showWeeks]="false" class="d-picker"></datepicker> -->
                  </div>
                </div>
              </div>
            }
          </div>
        </div><!-- .seasons-->
      </div>
      <!-- last row - Save/Cancel -->
      @if (editMode) {
        <div class="my-4 d-flex">
          <div class="pt-4 border-top flex-grow-1">
            @if (!loading) {
              <div class="row justify-content-center">
                <!-- Delete -->
                @if (event.active && event.id) {
                  <div class="col-12 col-sm text-center text-sm-left mb-5 mb-sm-0">
                    <button type="button" (click)="setEventForDelete(event); showDeleteDialog = !showDeleteDialog" class="btn btn-danger  px-4">{{ 'events.delete' | translate }}</button>
                    <app-dialog [(visible)]="showDeleteDialog" [closable]="false" class="app-dialog--confirm">
                      <div class="modal-header">
                        <h5 class="mb-0">{{ 'events.deleteConfirm' | translate }}</h5>
                      </div>
                      <div class="modal-footer justify-content-start">
                        <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showDeleteDialog = false">{{ 'common.no' | translate }}</button>
                        <button type="button" class="btn btn-primary text-white btn-sm px-3" (click)="removeEvent(); showDeleteDialog = false">{{ 'common.yes' | translate }}</button>
                      </div>
                    </app-dialog>
                  </div>
                }
                @if (event.viewedByManager) {
                  <div class="col-auto">
                    <button type="button" class="btn btn-secondary px-4 text-white" (click)="cancelEventDetailsChange()">{{ 'common.cancel' | translate }}</button>
                  </div>
                }
                @if (event.viewedByManager) {
                  <div class="col-auto">
                    <button type="submit" class="btn btn-primary px-4" [disabled]="!eventForm.form.valid">{{ 'common.save' | translate }}</button>
                  </div>
                }
              </div>
            }
            @if (loading && event.viewedByManager) {
              <div class="col d-flex justify-content-center">
                <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
              </div>
            }
          </div>
        </div>
      }
    </form>
    }
  </app-screen-shell>
}
